import { Injector } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent, HttpXsrfTokenExtractor } from '@angular/common/http';
import { BehaviorSubject, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./helpers";
import * as i3 from "./storage.service";
import * as i4 from "@angular/router";
export class TokenInterceptorService {
    constructor(injector, tokenExtractor, helper, storage, router) {
        this.injector = injector;
        this.tokenExtractor = tokenExtractor;
        this.helper = helper;
        this.storage = storage;
        this.router = router;
        this.isRefreshingToken = false;
        this.tokenSubject = new BehaviorSubject(null);
    }
    intercept(request, next) {
        if (this.isOneOfIgnoreredUrl(request)) {
            return next.handle(request);
        }
        const storage = this.injector.get(StorageService);
        const router = this.injector.get(Router);
        const authData = storage.getItem('premium|auth');
        let token = null;
        if (authData && authData.token) {
            token = authData.token;
        }
        return next.handle(this.addTokenToRequest(request, token, '')).pipe(catchError((err) => {
            if (request.url === this.helper.getAuthUrl()) {
                return throwError(err);
            }
            if (err instanceof HttpErrorResponse) {
                switch (err.status) {
                    case 401:
                        /*//2FA
                        if (_.get(err, 'error.error_description') === '2FA') {
                          return throwError(err);
                        }
                        //TODO ni najlepsa resitev
                        if (
                          _.get(request, 'body', '') &&
                          _.get(request, 'body', '').indexOf('refresh_token') !== -1
                        ) {
                          storage.clearToken();
                          router.navigate(['/login']);
                        }*/
                        return this.handle401Error(request, next);
                    case 400:
                        return throwError(err);
                    case 403:
                        return throwError(err);
                    default:
                        return throwError(err);
                }
            }
            else {
                return throwError(err);
            }
        }));
    }
    isOneOfIgnoreredUrl(request) {
        // return /public/.test(request.url) || /hooks.slack.com/.test(request.url);
        return false;
    }
    addTokenToRequest(request, token, XSRFToken) {
        if (!token) {
            return request.clone();
        }
        const useToken = true;
        /*
        if (request.body && _.isString(request.body)) {
          if (_.get(request, 'body', '').indexOf('refresh_token') !== -1) {
            useToken = false;
          }
        }
        if (!token) {
          useToken = false;
        }
        */
        if (useToken) {
            return request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
        }
        else {
            return request.clone();
        }
    }
    handle401Error(request, next) {
        this.storage.removeItem('premium|auth');
        this.router.navigate(['/login']);
        return of(false);
        //const httpClientMF = this.injector.get(HttpClient);
        //const authService = this.injector.get(AuthenticationService);
        /*if (!this.isRefreshingToken) {
          this.isRefreshingToken = true;
    
          // Reset here so that the following requests wait until the token
          // comes back from the refreshToken call.
          this.tokenSubject.next(null);
    
          return httpClientMF.refreshToken().pipe(
            switchMap((token: any) => {
              debugger;
              const accessToken = _.get(token, 'access_token', undefined);
              if (accessToken) {
                this.tokenSubject.next(accessToken);
                return next.handle(this.addTokenToRequest(request, accessToken, ''));
              }
    
              return <any>authService.logout();
            }),
            catchError((err) => {
              debugger;
              return <any>authService.logout();
            }),
            finalize(() => {
              debugger;
              this.isRefreshingToken = false;
            }),
          );
        } else {
          this.isRefreshingToken = false;
    
          return this.tokenSubject.pipe(
            filter((token) => token != null),
            take(1),
            switchMap((token) => {
              return next.handle(this.addTokenToRequest(request, token, ''));
            }),
          );
        }*/
    }
}
TokenInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TokenInterceptorService_Factory() { return new TokenInterceptorService(i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i1.HttpXsrfTokenExtractor), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.StorageService), i0.ɵɵinject(i4.Router)); }, token: TokenInterceptorService, providedIn: "root" });
